import * as React from "react";
import * as S from "@styled";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";
import { IElement } from "../model/IProcessData";

export const ExlusiveConditionBranchEditor: React.FC<ExclusiveDecisionProps> = (props) => {
    const handleSetDefaultBranchButtonClick = () => {
        BpmnJsCliWrapper.toggleDefaultBranch(props.id);
    };
    function renderDefaultBranchSwitch() {
        if (props.element.isDefault) {
            return (<span>{FRENDS.Localizations.IsDefaultBranch}</span>);
        }
        return (
            <S.Button onClick={handleSetDefaultBranchButtonClick} disabled={props.disabled}>{FRENDS.Localizations.SetAsDefaultBranch}</S.Button>
        );
    }

    return (
        <S.FormGroup id={props.id}>
            {renderDefaultBranchSwitch()}
        </S.FormGroup>
    );
};

interface ExclusiveDecisionProps {
    id: string;
    element: IElement;
    disabled?: boolean;
}
